export default "__VITE_ASSET__CZLII6Gy__"